/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useRef, useEffect } from "react";
import {
  Modal,
  Grid,
  TextField,
  MenuItem,
  Select,
  Card,
  Button,
  CardMedia,
  CircularProgress,
  CardContent,
} from "@mui/material";

import {
  rankarr,
  perscorpsarr,
  persgrpsarr,
  rtafunitarr,
} from "./GlobalUseData";

import { useDispatch, useSelector } from "react-redux";
import {
  updateMemberInfo,
  addCandAtDueDate,
} from "../store/TestReservationSlice";
import { toast } from "react-toastify";

function ModalUpdateMember(props) {
  /*----------------------------- member info ----------------------------*/
  const [persidValue, setPersIdValue] = useState(
    props.editrowinfo[0]["pers_id"]
  );

  /*------------------------- updated on 06-05-2024 ---------------------------*/
  const [persNameValue, setPersNameValue] = useState(
    Object.keys(props.editrowinfo[0]).some((k) => k === "name")
      ? props.editrowinfo[0]["name"]
      : props.editrowinfo[0]["fname"].concat(" ", props.editrowinfo[0]["lname"])
  );
  /*---------------------------------------------------------------------------*/
  const [persPositionValue, setPersPositionValue] = useState(
    props.editrowinfo[0]["position"]
  );
  const [rank, setRank] = useState(
    rankarr.indexOf(props.editrowinfo[0]["rank"])
  );
  const [perscorps, setPersCorps] = useState(
    perscorpsarr.indexOf(props.editrowinfo[0]["branch"])
  );
  const [persgrps, setPersGrps] = useState(
    persgrpsarr.indexOf(props.editrowinfo[0]["branchgrp"])
  );
  const [rtafunit, setRtafUnit] = useState(
    Object.keys(rtafunitarr).indexOf(props.editrowinfo[0]["affiliation"])
  );
  const [persCellPhone, setPersCellPhone] = useState(
    props.editrowinfo[0]["cellphone"]
  );
  const [persOffTel, setPersOffTel] = useState(props.editrowinfo[0]["offtel"]);
  const [persEmail, setPersEmail] = useState(props.editrowinfo[0]["email"]);

  const [imgloading, setImgLoading] = useState(false);
  //const [openImgPanel, setOpenImgPanel] = useState(false);
  const [imagesString, setImagesString] = useState(""); //------> updated on 04-10-2567
  const [imgAlt, setImgAlt] = useState(""); //------> updated on 04-10-2567
  let imgBlobSrc = null; //------> updated on 04-10-2567

  const getBase64Image = async (res) => {
    const blob = await res.blob();
    const reader = new FileReader();
    await new Promise((resolve, reject) => {
      reader.onload = resolve;
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

    /*****************  added on 04-10-2024 **************************/
    function isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
    imgBlobSrc = isJsonString(await blob.text())
      ? JSON.parse(await blob.text())
      : await blob.text();
    if (typeof imgBlobSrc !== "string") {
      setImgLoading(false);
    }

    return reader.result;
  };

  /*---------------------------- Modal Open/Close -----------------------*/
  useMemo(() => {
    setImgLoading(true);
    /*------------ added on 04-10-2024 ----------------------*/
    const loadingImgFunc = async () => {
      const token = localStorage.getItem("token");
      await fetch(
        `${process.env.REACT_APP_API_URL}/pagebookdate/previmgfileformhris/pers_id/${props.editrowinfo[0]["pers_id"]}`,
        {
          headers: {
            authtoken: `Bearer ${token}`,
          },
        }
      )
        .then(getBase64Image)
        .then((imgString) => {
          setImagesString(imgString);
          setImgAlt(
            typeof imgBlobSrc !== "string"
              ? "ไม่พบรูปถ่ายของข้าราชการในระบบ HRIS"
              : ""
          ); //------> updated on 04-10-2567
        });
      //.then(() => {
      //setImgLoading(true);
      //    setOpenImgPanel(true);
      //});
    };

    loadingImgFunc();
  }, [props.editrowinfo[0]["pers_id"]]);

  const [open, setOpen] = useState(props.open);
  //const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    props.setOpen(false);
  };

  /*----------------------------- Redux ---------------------------------*/
  /*--------------------------- added on 06-05-2024 ---------------------*/
  const updateMbrInfoDispatch = useDispatch();

  /*---------------- update meminfo -----------------------*/
  const testresvinfodispatch = useDispatch();
  const updatembrlistref = useRef({});
  const prev_memberlist = useSelector(
    (state) => state.testresvinfostate.candAtDueDateArr
  );
  /*useMemo(() => {
        updatembrlistref.current = Object.assign({}, prev_memberlist);
    }, [open, prev_memberlist]);*/

  useEffect(() => {
    const tmpfunc = async () => {
      let tmp = await Promise.all([prev_memberlist]);
      updatembrlistref.current = Object.assign({}, tmp[0]);
    };
    tmpfunc();
  }, [open]);

  //console.log('updatembrlistref.current ---> ', updatembrlistref.current, ' : prev_memberlist ->', prev_memberlist);

  /*---------------------- update member in the List ---------------------------*/
  const updateMbrList = (updatembrinfo) => {
    updatembrlistref.current["member"] = updatembrlistref.current["member"].map(
      (meminfo) => {
        let tmpmeminfo = Object.assign({}, meminfo);
        if (tmpmeminfo.pers_id === updatembrinfo["IDCARD"]) {
          //tmpmeminfo['pers_id'] = updatembrinfo['IDCARD'];
          //tmpmeminfo['official_id'] = updatembrinfo['AIRFORCE_ID'];
          tmpmeminfo["name"] = updatembrinfo["FIRSTNAME"].concat(
            " ",
            updatembrinfo["LASTNAME"]
          );
          tmpmeminfo["position"] = updatembrinfo["POSITION"];
          tmpmeminfo["rank"] = updatembrinfo["RANK"];
          tmpmeminfo["branch"] = updatembrinfo["ARMCODE"];
          tmpmeminfo["branchgrp"] = updatembrinfo["SPC_NAME"];
          tmpmeminfo["affiliation"] = updatembrinfo["UNITNAME"];
          tmpmeminfo["cellphone"] = updatembrinfo["mem_cellphone"];
          tmpmeminfo["offtel"] = updatembrinfo["mem_offtel"];
          tmpmeminfo["email"] = updatembrinfo["EMAIL"].split("@")[0];
        }
        return tmpmeminfo;
      }
    );

    return updatembrlistref.current;
  };
  /*-------------------- Return ----------------------------------------*/
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          maxWidth: 750,
          maxHeight: 750,
          padding: 10,
        }}
      >
        <Grid container columnSpacing={1} rowSpacing={1}>
          <Grid
            item
            xs={12}
            sx={{
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
            }}
          >
            แก้ไขข้อมูลของผู้เข้าสอบ
          </Grid>
          <Grid item xs={12}></Grid>
          {/*-------------- เลขประจำตัวประชาชน และรูป ----------*/}
          <Grid
            item
            xs={3}
            sx={{
              fontSize: 12,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
            alignItems="flex-end"
          >
            เลขประจำตัวประชาชน:
          </Grid>
          <Grid
            item
            xs={3}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
            }}
            alignItems="flex-end"
          >
            <TextField
              inputProps={{
                maxLength: 13,
                style: { fontSize: 12 },
              }}
              value={persidValue}
              disabled={true}
              onChange={(evt) => {
                setPersIdValue(evt.target.value);
              }}
            />
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
            alignItems="center"
          >
            <CardContent>
              <CardMedia
                component="img"
                src={imagesString} //---> updated on 04-10-2024
                alt={imgAlt} //---> updated on 04-10-2024
                style={{
                  height: 150,
                  width: 150,
                  padding: "1em 1em 0 1em",
                  objectFit: "contain",
                  fontSize: "0.75em",
                }}
                onLoad={() => {
                  setImgLoading(false);
                }}
              />
              {imgloading && (
                <CircularProgress
                  size={24}
                  sx={{
                    position: "absolute",
                    top: "25%",
                    left: "65%",
                    marginTop: "-12px",
                    marginLeft: "-6px",
                  }}
                />
              )}
            </CardContent>
          </Grid>
          {/*-------------- ยศ ----------*/}
          <Grid
            item
            xs={3}
            sx={{
              fontSize: 12,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
            alignItems="center"
          >
            ยศ:
          </Grid>
          <Grid item xs={3}>
            <Select
              value={rank}
              disabled={true}
              onChange={(newRank) => {
                setRank(newRank.target.value);
              }}
            >
              {rankarr.map((rnk, i) => {
                return (
                  <MenuItem key={i} value={i}>
                    {rnk}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>
          {/*-------------- ชื่อ ----------*/}
          <Grid
            item
            xs={3}
            sx={{
              fontSize: 12,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
            alignItems="center"
          >
            ชื่อ:
          </Grid>
          <Grid item xs={3}>
            <TextField
              inputProps={{
                style: { fontSize: 12 },
              }}
              value={persNameValue}
              disabled={true}
              onChange={(evt) => {
                setPersNameValue(evt.target.value);
              }}
            />
          </Grid>
          {/*-------------- ตำแหน่ง ----------*/}
          <Grid
            item
            xs={3}
            sx={{
              fontSize: 12,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
            alignItems="center"
          >
            ตำแหน่ง:
          </Grid>
          <Grid item xs={3}>
            <TextField
              value={persPositionValue}
              disabled={true}
              onChange={(evt) => {
                setPersPositionValue(evt.target.value);
              }}
            />
          </Grid>
          {/*-------------- เหล่า ----------*/}
          <Grid
            item
            xs={3}
            sx={{
              fontSize: 12,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
            alignItems="center"
          >
            เหล่า:
          </Grid>
          <Grid item xs={3}>
            <Select
              value={perscorps}
              disabled={true}
              onChange={(newRank) => {
                setPersCorps(newRank.target.value);
              }}
            >
              {perscorpsarr.map((rnk, i) => {
                return (
                  <MenuItem key={i} value={i}>
                    {rnk}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>
          {/*-------------- จำพวก ----------*/}
          <Grid
            item
            xs={3}
            sx={{
              fontSize: 12,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
            alignItems="center"
          >
            จำพวก:
          </Grid>
          <Grid item xs={3}>
            <Select
              value={persgrps}
              disabled={true}
              onChange={(newRank) => {
                setPersGrps(newRank.target.value);
              }}
            >
              {persgrpsarr.map((rnk, i) => {
                return (
                  <MenuItem key={i} value={i}>
                    {rnk}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>
          {/*-------------- สังกัด ----------*/}
          <Grid
            item
            xs={3}
            sx={{
              fontSize: 12,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
            alignItems="center"
          >
            สังกัด:
          </Grid>
          <Grid item xs={3}>
            <Select
              value={rtafunit}
              disabled={true}
              onChange={(newRank) => {
                setRtafUnit(newRank.target.value);
              }}
            >
              {Object.keys(rtafunitarr).map((rnk, i) => {
                return (
                  <MenuItem key={i} value={i}>
                    {rnk}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>
          {/*-------------- เบอร์มือถือ ----------*/}
          <Grid
            item
            xs={3}
            sx={{
              fontSize: 12,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
            alignItems="center"
          >
            เบอร์มือถือ:
          </Grid>
          <Grid item xs={3}>
            <TextField
              inputProps={{ maxLength: 10 }}
              value={persCellPhone}
              onChange={(evt) => {
                setPersCellPhone(evt.target.value);
              }}
            />
          </Grid>
          {/*-------------- เบอร์ที่ทำงาน ----------*/}
          <Grid
            item
            xs={3}
            sx={{
              fontSize: 12,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
            alignItems="center"
          >
            เบอร์ที่ทำงาน:
          </Grid>
          <Grid item xs={3}>
            <TextField
              inputProps={{
                maxLength: 5,
              }}
              style={{
                width: 80,
              }}
              value={persOffTel}
              onChange={(evt) => {
                setPersOffTel(evt.target.value);
              }}
            />
          </Grid>
          {/*-------------- E-mail ----------*/}
          <Grid
            item
            xs={3}
            sx={{
              fontSize: 12,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
            alignItems="center"
          >
            E-mail:
          </Grid>
          <Grid item xs={3}>
            <TextField
              value={persEmail}
              disabled={true}
              onChange={(evt) => {
                setPersEmail(evt.target.value);
              }}
            />
          </Grid>
          <Grid item xs={6}></Grid>
          {/*-------------- Button ----------*/}
          <Grid item xs={12} padding={2}></Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              onClick={() => {
                // console.log("test");
                let updatembrinfo = {
                  RANK: rankarr[rank],
                  FIRSTNAME: persNameValue.split(" ")[0],
                  LASTNAME: persNameValue.split(" ")[1],
                  AIRFORCE_ID: "",
                  UNITNAME: Object.keys(rtafunitarr)[rtafunit],
                  ARMCODE: perscorpsarr[perscorps],
                  SPC_NAME: persgrpsarr[persgrps],
                  POSITION: persPositionValue,
                  EMAIL: persEmail.concat("@rtaf.mi.th"),
                  IDCARD: persidValue,
                  mem_cellphone: persCellPhone,
                  mem_offtel: persOffTel,
                };
                updateMbrInfoDispatch(updateMemberInfo(updatembrinfo)).then(
                  (res) => {
                    if (
                      res.payload.data.infostatus.updatestatus === "success"
                    ) {
                      setOpen(false);
                      props.setOpen(false);
                      toast.success(
                        "เพิ่มและอัพเดทข้อมูลผู้เข้าสอบเรียบร้อยแล้ว",
                        { position: toast.POSITION.TOP_CENTER }
                      );

                      //console.log('Modal 440 -----> hrisinfo : ', res.payload.data.hrisinfo)
                      testresvinfodispatch(
                        addCandAtDueDate(
                          updateMbrList(res.payload.data.hrisinfo)
                        )
                      );
                    } else {
                      toast.warning(
                        "ไม่สามารถเพิ่มและอัพเดทข้อมูลผู้เข้าสอบได้ กรุณาตรวจสอบ",
                        { position: toast.POSITION.TOP_CENTER }
                      );
                    }
                  }
                );
              }}
            >
              ตกลง
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              onClick={() => {
                setOpen(false);
                props.setOpen(false);
              }}
            >
              ปิด
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Modal>
  );
}

export default ModalUpdateMember;
